export const packageJson = {
  version: '1.2.45',
  name: '@senx/discovery-widgets',
  description: 'Discovery Widgets Elements',
  author: 'SenX <contact@senx.io>',
  license: 'Apache-2.0',
  homepage: 'https://discovery.warp10.io/'
}